<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M8,0C8,0,0,16,0,16C0,16,16,16,16,16C16,16,8,0,8,0C8,0,8,0,8,0ZM7,5C7,5,12,15,12,15C12,15,2,15,2,15C2,15,7,5,7,5C7,5,7,5,7,5Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Delta',
} as DefineComponent
</script>
